import React, { useContext, useEffect, useState } from 'react'
import styles from './BasicInformation.module.css'
import { FormTitle } from '../../../../Common/FormTitle'
import { NextButton } from '../../../../Common/CtaButton/NextButton'
import { handleNumericInput, validateDate } from '../../Birthday/validate'
import { DATE_CONSTANTS } from '../../../../../constants/progressBanner'
import { HandleYearChangeFunction, SetMonthFunction } from '../../Birthday/types'
import { useAbTestGtm } from '../../../../../hooks/useAbTestGtm'
import { StepContext } from '../../../StepContainer'
import { BirthdayField } from './BirthdayField'
import { AgeCaluculation } from '../../Birthday/AgeCaluculation'

export const JobSeekerBirthdayOnly = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const { formState } = useContext(StepContext)

    const storedBirthday = formState.birthday // e.g. '2000-05-01'
    const [year, setYear] = useState<string>(storedBirthday ? storedBirthday.split('-')[0] : '')
    const [month, setMonth] = useState<string>(storedBirthday ? String(parseInt(storedBirthday.split('-')[1], 10)) : '')
    const [hasInteractedBirthday, setHasInteractedBirthday] = useState<boolean>(false)
    const [birthdayValid, setBirthdayValid] = useState<boolean>(false)
    const [birthdayValidateMessage, setBirthdayValidateMessage] = useState<string>('')
    const [age, setAge] = useState<number | null>(null)

    const currentDate = new Date()
        .toISOString()
        .slice(0, DATE_CONSTANTS.DATE_SLICE_END)

    useEffect(() => {
        if (hasInteractedBirthday) {
            setBirthdayValid(
                validateDate(year, month, currentDate, setBirthdayValidateMessage)
            )
        } else if (year !== '' || month !== '') {
            setHasInteractedBirthday(true)
        }

        if (year && month && currentDate) {
            const calculatedAge = AgeCaluculation({
                year,
                month,
                currentDate,
            })
            setAge(calculatedAge)
        }
    }, [month, year, hasInteractedBirthday, currentDate])

    const birthday =
        year !== '' && month !== ''
            ? `${year}-${String(month).padStart(DATE_CONSTANTS.MONTH_START_PAD, '0')}-01`
            : null

    const normalizeMonthValue = (value: string): string => {
        const numericValue = value.replace(/[^0-9]/g, '')
        const MAX_MONTH_LENGTH = 2
        return numericValue.length > MAX_MONTH_LENGTH
            ? numericValue.replace(/^0+/, '')
            : numericValue
    }

    const isValidMonth = (value: string): boolean => {
        const MAX_MONTH = 12
        return value === '' || parseInt(value, 10) <= MAX_MONTH
    }

    const handleMonthChange: SetMonthFunction = value => {
        const normalizedValue = normalizeMonthValue(value)
        if (isValidMonth(normalizedValue)) {
            setMonth(normalizedValue)
            if (!hasInteractedBirthday) setHasInteractedBirthday(true)
        }
    }

    const handleYearChange: HandleYearChangeFunction = value => {
        handleNumericInput(value, setYear)
        if (!hasInteractedBirthday) setHasInteractedBirthday(true)
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText='生年月日を教えてください'
                        dataViewLabel={dataViewLabel('EF_StepForm_生年月日')}
                        dataClickLabel={dataClickLabel('EF_StepForm_生年月日-戻る')}
                    />
                </div>

                <BirthdayField
                    year={year}
                    month={month}
                    onYearChange={handleYearChange}
                    onMonthChange={handleMonthChange}
                    hasInteractedBirthday={hasInteractedBirthday}
                    birthdayValidateMessage={birthdayValidateMessage}
                    yearLabel='誕生年'
                    monthLabel='誕生月'
                />

                <NextButton
                    formKey={['birthday']}
                    formValue={[birthday || '']}
                    displayFormKey={['birthday']}
                    displayFormValue={[
                        year && month && age !== null ? `${year}年${month}月(${age}歳)` : '',
                    ]}
                    isDisabled={!birthdayValid}
                    dataClickLabel={dataClickLabel('EF_StepForm_生年月日-次へ')}
                />
            </div>
        </div>
    )
}
